export default "/fonts/vendor/katex/dist/KaTeX_SansSerif-Bold.woff2?95591a929f0d32aa282a90ba5acf81f0";